import { graphql } from '@/gql';
import { CurrencyType, ServiceType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchPaymentTiers = async ({
  service,
  currency,
  code,
  isActive,
}: {
  service?: ServiceType;
  currency?: CurrencyType;
  code?: string;
  isActive?: boolean;
} = {}) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      service,
      currency,
      code,
      isActive,
    },
    query: graphql(`
      query paymentTiers($service: ServiceType, $currency: CurrencyType, $code: String, $isActive: Boolean) {
        paymentTiers(service: $service, currency: $currency, code: $code, isActive: $isActive) {
          id
          code
          service
          currency
          unit
          chargePerOrder
          chargePerUnit
          chargePerUnitForSelfOrdering
          maxCharge
          isActive
          createdAt
        }
      }
    `),
  });

  return response.data.paymentTiers;
};
